import axiosInstance from "../axiosInstance";

export const POSTNuevaReubicacion = async () => {
  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_WMS_BASE_URL}/ordenes/nueva-reubicacion`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default POSTNuevaReubicacion;
